// ---------------------------------------------------------------------------------------------------------------------
// inits

// createApp().mount();
let now = new Date();
let hours = now.getHours();
let minutes = now.getMinutes();
let timestamp = `[${hours}${minutes}]`; // '[1847]';
window.timestamp = timestamp;

// ---------------------------------------------------------------------------------------------------------------------
// 3rd-party imports
// process.env.NODE_ENV = 'development';

// import '../scss/test.css';

// manual import
// import '../../../../node_modules/jquery/dist/jquery.min.js';

// import as npm module
// import $ from 'jquery';

// require("jquery-match-height");
// import "jquery-match-height";

// ---------------------------------------------------------------------------------------------------------------------
// import npm packages

import "../../../../node_modules/slick-carousel/slick/slick.min.js"; 

// wrapper for maplibre-gl
import './3rdparty/jquery';
import './3rdparty/easing';
import './3rdparty/scrollto';
import './3rdparty/localscroll';

// ---------------------------------------------------------------------------------------------------------------------
// local imports

import './lib/tools';
import './tools/breakpoints';

import './partials/nav';
import './partials/modal';
import './partials/search';

import './pages/startpage';
import './pages/lexikon';








// ---------------------------------------------------------------------------------------------------------------------

console.log(timestamp + ' javascript loaded ready ...');

$(function(){

	console.log(timestamp + ' dom ready ...');

});








